import { getCatalogPaymentProvider, getCatalogRequiredACH } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import {
    getItemModelCatalogId,
    getItemModelStartPrice,
    getItemSummaryLeadingBid,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { PaymentProviders } from '@/enums';
import { useAppSelector } from '@/redux/hooks';
import { ZipPay } from '@liveauctioneers/hammer-ui-liveauctioneers/lotDetail';

const TOTAL_ALLOWED_TO_BE_SPLIT_INTO_PAYMENTS_FOR_ACH = 3000;
const TOTAL_ALLOWED_TO_BE_SPLIT_INTO_PAYMENTS_PLUS_ONE_FOR_BID_INCREMENT = 3001;
const TOTAL_PAYMENTS_ALLOWED_BY_ZIP = 4;
type Props = {
    itemId: number;
};

export const useGetBidCanvasZipData = ({ itemId }: Props): ZipPay => {
    const catalogId = useAppSelector((state) => getItemModelCatalogId(state, itemId));
    const startPrice = useAppSelector((state) => getItemModelStartPrice(state, itemId)) || 0;
    const leadingBid = useAppSelector((state) => getItemSummaryLeadingBid(state, itemId)) || 0;
    const paymentProvider = useAppSelector((state) => getCatalogPaymentProvider(state, catalogId));
    const requiredACH = useAppSelector((state) => getCatalogRequiredACH(state, catalogId));

    // bid amount has to be less than 3000, has to be Payrix, and required ach must be over 3000
    const showZipOption =
        (leadingBid || startPrice) < TOTAL_ALLOWED_TO_BE_SPLIT_INTO_PAYMENTS_PLUS_ONE_FOR_BID_INCREMENT &&
        paymentProvider === PaymentProviders.Payrix &&
        (requiredACH === 0 || requiredACH > TOTAL_ALLOWED_TO_BE_SPLIT_INTO_PAYMENTS_FOR_ACH);

    if (showZipOption) {
        return {
            zipLogoUrl: 'https://p1.liveauctioneers.com/dist/images/zip-logo.svg',
            zipPaymentAmount: (leadingBid || startPrice) / TOTAL_PAYMENTS_ALLOWED_BY_ZIP,
        };
    }

    return undefined;
};
